import React from 'react';

const ErrorMessage = ({message = ''}) => {
  return <span className="error">{message}</span>;
};

export default ErrorMessage;
